import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ROLE_TYPES, SORTING_PROPS, VIEW_ENTITY_TYPES } from '../../utils/DataConstants';
import PaginatedReduxTable from '../paginated_redux_table/PaginatedReduxTable';
import { Row } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { savedFilterViewsRestCrudThunksForBuyer } from '../../thunks/saved_filter_views_thunks';
import { BUYER_ADMIN_ONLY } from '../roles/roles';
import SavedFilterViewEmptyState from '../saved_filter_views/SavedFilterViewEmptyState';
import SavedFilterViewsRowDisplay from '../saved_filter_views/SavedFilterViewsRowDisplay';
import { getDefaultWorkOrderTab } from '../../utils/HistoryUtils';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import {
	getAttentionDashboard,
	updateAttentionDashboard,
} from '../../thunks/attention_dashboard_thunks';
import posthog from 'posthog-js';
import { withUserType } from '../withUserType';

const queryString = require('qs');
const WORK_ORDERS_SAVED_FILTER_VIEWS_TARGET_COLLECTION = 'workOrdersSavedViewsIndex';

const WorkOrdersSavedFiltersViewIndexPage = ({
	location,
	currentUser,
	deleteSavedFilterView,
	history,
	saveAttentionDashboard,
	attentionDashboards,
	getWorkOrderViews,
}): React.ReactElement => {
	const [loading, setLoading] = useState(false);
	const searchString = useMemo(
		() => (location.search[0] === '?' ? location.search.slice(1) : location.search),
		[location]
	);

	const queryParams = queryString.parse(searchString);
	const { current, pageSize, sort_by, order } = queryParams;
	const initialPagination = {
		current: current ? current : 1,
		pageSize: pageSize ? pageSize : 5,
	};
	const initialSorting = {
		sort_by: sort_by ? sort_by : 'isPublic',
		order: order ? order : 'ascend',
	};
	const initialFilters = {
		entityType: VIEW_ENTITY_TYPES.WORKORDERS,
	};

	const isAdmin = useMemo(() => {
		return currentUser.roles.some((role) => BUYER_ADMIN_ONLY.has(role));
	}, [currentUser]);

	const onOpenView = useCallback(
		(view) => {
			history.push(
				`/buyer/workOrders/overview/${getDefaultWorkOrderTab(currentUser, view.filterValue)}?${
					view.filterQuery
				}`
			);
		},
		[history]
	);
	useEffect(() => {
		setLoading(true);
		getWorkOrderViews().then(() => setLoading(false));
	}, []);

	const setDefault = useCallback(
		(id) => {
			saveAttentionDashboard({
				...attentionDashboards,
				defaultWorkOrderFilterViewId:
					nullSafeGet('defaultWorkOrderFilterViewId', attentionDashboards) === id ? undefined : id,
			});
		},
		[attentionDashboards]
	);

	const columns = [
		{
			title: '',
			dataIndex: initialSorting.sort_by,
			defaultSortOrder: initialSorting.order,
			order: initialSorting.order,
			sort_by: initialSorting.sort_by,
			render: (_, record) => (
				<Row>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							width: '100%',
							alignItems: 'baseline',
						}}
					>
						<SavedFilterViewsRowDisplay
							record={record}
							isAdmin={isAdmin}
							onOpenView={onOpenView}
							onDelete={deleteSavedFilterView}
							allowSetDefault={!loading}
							isDefault={
								record.id === nullSafeGet('defaultWorkOrderFilterViewId', attentionDashboards)
							}
							setDefault={setDefault}
						/>
					</div>
				</Row>
			),
		},
	];

	return (
		<div style={{ padding: '24px' }}>
			<PaginatedReduxTable
				tableLayoutFixed={true}
				updateQueryParams={true}
				showHeader={false}
				emptyState={<SavedFilterViewEmptyState entityType={VIEW_ENTITY_TYPES.WORKORDERS} />}
				collectionName="saved_filter_views"
				targetCollectionName={WORK_ORDERS_SAVED_FILTER_VIEWS_TARGET_COLLECTION}
				columns={columns}
				initialFilters={initialFilters}
				initialPagination={initialPagination}
				fetchData={savedFilterViewsRestCrudThunksForBuyer.read}
			/>
		</div>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
	attentionDashboards: state.attention_dashboards.detail,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	deleteSavedFilterView: (entity) =>
		dispatch(savedFilterViewsRestCrudThunksForBuyer.delete(entity)),
	saveAttentionDashboard: (entity) => updateAttentionDashboard(dispatch, ownProps.userType, entity),
	getWorkOrderViews: () => getAttentionDashboard(dispatch, ownProps.userType),
});

export default withRouter<any, any>(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(WorkOrdersSavedFiltersViewIndexPage))
);
